import { Typography } from '@mui/material';
import ProductTourContent from 'src/components/ProductTourContent';
import { IProductTour } from 'src/models/productTour';

export const CreateObjectStep: IProductTour = {
  title: 'How to Set Up Object',
  menu: 'settings',
  submenu: 'object',
  steps: [
    {
      title: "Let's Get Your Objects Ready!",
      content: (
        <ProductTourContent alignItems="center" spacing={1} direction="row">
          All social profiles, keywords, and hashtags are monitored objects.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Start the Tour'
    },
    {
      title: 'Open Settings Menu',
      content: (
        <ProductTourContent alignItems="center" spacing={1} direction="row">
          Click here to open the settings menu.
        </ProductTourContent>
      )
    },
    {
      title: 'Open Object Settings',
      content: (
        <ProductTourContent alignItems="center" spacing={1} direction="row">
          <Typography fontSize="12px">
            Click <strong>Manage</strong> to access object settings.
          </Typography>
        </ProductTourContent>
      )
    },
    {
      title: 'Add a New Social Profile',
      content: (
        <ProductTourContent alignItems="center" spacing={1} direction="row">
          You can add new social profiles here (click the button).
        </ProductTourContent>
      )
    },
    {
      title: 'Add a New Social Profile',
      content: (
        <ProductTourContent alignItems="center" spacing={1} direction="row">
          Select the social media platform first, then type the social profile
          name or enter the URL in the field. After you're done, click the Save
          button.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'Add New Keywords and Hashtags',
      content: (
        <ProductTourContent alignItems="center" spacing={1} direction="row">
          You can add new keywords and hashtags here (click the button).
        </ProductTourContent>
      )
    },
    {
      title: 'Add New Keywords and Hashtags',
      content: (
        <ProductTourContent alignItems="center" spacing={1} direction="row">
          Type the keyword or hashtag. If you need an advanced search for more
          accurate results, click the Filter button to the right of the search
          bar. Once finished, click the Save button.
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Next'
    },
    {
      title: 'The Final Step',
      content: (
        <ProductTourContent spacing={2}>
          <Typography fontSize="12px">
            All steps are complete. You've successfully finished this stage and
            are now ready to continue exploring and using all available
            features.
          </Typography>
          <Typography fontSize="12px">
            <strong>Tips:</strong> You can add, edit, or remove objects by going
            to the Monitored Assets settings.
          </Typography>
        </ProductTourContent>
      ),
      showNextButton: true,
      nextButtonText: 'Finish'
    }
  ]
};
